var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.column == '12')?_c('button',{staticClass:"btn btn-sm text-success",staticStyle:{"margin-right":"30px"}},[_c('strong',[_vm._v("100%")])]):_vm._e(),(_vm.column == '6')?_c('button',{staticClass:"btn btn-sm text-warning",staticStyle:{"margin-right":"30px"}},[_c('strong',[_vm._v("50%")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }